module.exports = __webpack_public_path__ + "static/dolly-s.4dce13cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/dolly-s.jpg
// module id = 477
// module chunks = 35783957827783